import { getMIPInvestorKycData } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useQuery } from '@tanstack/react-query';

export const useInvestorKYC = (isEnabled: boolean, investorId?: string, kycWorkflowId?: string) => {
	const getInvestorKYCDataRequest = useQuery({
		queryKey: [API_PATHS.MIP_KYC_INVESTORS_INVESTORID_GET, { investorId, kycWorkflowId }],
		queryFn: ({ signal }) =>
			getMIPInvestorKycData(
				API_PATHS.MIP_KYC_INVESTORS_INVESTORID_GET,
				{ investorId, kycWorkflowId },
				signal
			),

		enabled: !!investorId && isEnabled,
	});

	return getInvestorKYCDataRequest;
};
